import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts'; 
import { ChartConfiguration, ChartData } from 'chart.js';

import { AnalysisOptionsComponent } from './../../tools/analysis-options/analysis-options.component';
import { AnalysisServiceService } from './../../services/analysis-service/analysis-service.service';

//Variables del Navegador
type MenuItem = 'wl' | 'wc';

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}

@Component({
  selector: 'evp-free',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective,],
  templateUrl: './evp-free.component.html',
  styleUrl: './evp-free.component.css'
})
export class EvpFreeComponent {
  selectedMenuItem: MenuItem = 'wl';
  @Input() checked: boolean; //Variable del mat-slide-toggle del text-component

  activeEyeIcon: HTMLImageElement | null = null;

  //Valores para expandir cada Cuadro
  public isExpanded: ExpandedState = {
    A1: false,
    A2: false,
    B1: false,
    B2: false,
    C1: false,
    C2: false,
    UNLISTED: false
  };

  //Variables Pagina 1 WordList
  public datos_pagina_A1={
    unique_words:90,
    words:214,
    cumul_unique:33.33,
    cumul_words:50.47,
    suma_unique_words:33.33,
    suma_cumul_words:50.5,
  }
  public datos_pagina_A2={
    unique_words:45,
    words:57,
    cumul_unique:16.67,
    cumul_words:13.44,
    suma_unique_words:50,
    suma_cumul_words:63.9,
  }
  public datos_pagina_B1={
    unique_words:35,
    words:36,
    cumul_unique:12.96,
    cumul_words:8.49,
    suma_unique_words:63,
    suma_cumul_words:72.4,
  }
  public datos_pagina_B2={
    unique_words:25,
    words:27,
    cumul_unique:9.26,
    cumul_words:6.37,
    suma_unique_words:72.2,
    suma_cumul_words:78.8,
  }
  public datos_pagina_C1={
    unique_words:9,
    words:10,
    cumul_unique:3.33,
    cumul_words:2.36,
    suma_unique_words:75.5,
    suma_cumul_words:81.1,
  }
  public datos_pagina_C2={
    unique_words:2,
    words:2,
    cumul_unique:0.74,
    cumul_words:0.47,
    suma_unique_words:76.3,
    suma_cumul_words:81.6,
  }
  public datos_pagina_unlisted={
    unique_words:64,
    words:78,
    cumul_unique:23.7,
    cumul_words:18.4,
    suma_unique_words:'~100',
    suma_cumul_words:'~100',
  }

  //Variables Pagina 1 WordList
  public unique_words_A1: number | undefined | null;
  public words_A1: number | undefined | null;
  public cumul_unique_A1: number | undefined | null;
  public cumul_words_A1: number | undefined | null;

  public unique_words_A2: number | undefined | null;
  public words_A2: number | undefined | null;
  public cumul_unique_A2: number | undefined | null;
  public cumul_words_A2: number | undefined | null;

  public unique_words_B1: number | undefined | null;
  public words_B1: number | undefined | null;
  public cumul_unique_B1: number | undefined | null;
  public cumul_words_B1: number | undefined | null;

  public unique_words_B2: number | undefined | null;
  public words_B2: number | undefined | null;
  public cumul_unique_B2: number | undefined | null;
  public cumul_words_B2: number | undefined | null;

  public unique_words_C1: number | undefined | null;
  public words_C1: number | undefined | null;
  public cumul_unique_C1: number | undefined | null;
  public cumul_words_C1: number | undefined | null;

  public unique_words_C2: number | undefined | null;
  public words_C2: number | undefined | null;
  public cumul_unique_C2: number | undefined | null;
  public cumul_words_C2: number | undefined | null;

  public unique_words_unlisted: number | undefined | null;
  public words_unlisted: number | undefined | null;
  public cumul_unique_unlisted: number | undefined | null;
  public cumul_words_unlisted: number | undefined | null;

  currentEnglishType2 = "";

  ngOnInit(): void {
    //Variables Pagina 1 WordList
    this.unique_words_A1 = this.datos_pagina_A1.unique_words;
    this.words_A1 = this.datos_pagina_A1.words;
    this.cumul_unique_A1 = this.datos_pagina_A1.cumul_unique;
    this.cumul_words_A1 = this.datos_pagina_A1.cumul_words;

    this.unique_words_A2 = this.datos_pagina_A2.unique_words;
    this.words_A2 = this.datos_pagina_A2.words;
    this.cumul_unique_A2 = this.datos_pagina_A2.cumul_unique;
    this.cumul_words_A2 = this.datos_pagina_A2.cumul_words;

    this.unique_words_B1 = this.datos_pagina_B1.unique_words;
    this.words_B1 = this.datos_pagina_B1.words;
    this.cumul_unique_B1 = this.datos_pagina_B1.cumul_unique;
    this.cumul_words_B1 = this.datos_pagina_B1.cumul_words;

    this.unique_words_B2 = this.datos_pagina_B2.unique_words;
    this.words_B2 = this.datos_pagina_B2.words;
    this.cumul_unique_B2 = this.datos_pagina_B2.cumul_unique;
    this.cumul_words_B2 = this.datos_pagina_B2.cumul_words;

    this.unique_words_C1 = this.datos_pagina_C1.unique_words;
    this.words_C1 = this.datos_pagina_C1.words;
    this.cumul_unique_C1 = this.datos_pagina_C1.cumul_unique;
    this.cumul_words_C1 = this.datos_pagina_C1.cumul_words;

    this.unique_words_C2 = this.datos_pagina_C2.unique_words;
    this.words_C2 = this.datos_pagina_C2.words;
    this.cumul_unique_C2 = this.datos_pagina_C2.cumul_unique;
    this.cumul_words_C2 = this.datos_pagina_C2.cumul_words;

    this.unique_words_unlisted = this.datos_pagina_unlisted.unique_words;
    this.words_unlisted = this.datos_pagina_unlisted.words;
    this.cumul_unique_unlisted = this.datos_pagina_unlisted.cumul_unique;
    this.cumul_words_unlisted = this.datos_pagina_unlisted.cumul_words;

    
     this.analysisService.currentEnglishType.subscribe(mode => {
      if(mode === "american"){
        this.currentEnglishType2 = "American English";
      }
      else{
        this.currentEnglishType2 = "British English";
      }
      
    });

  }

  public data: Data = {
    A1: [
      { word: "average", count: 1 },
      { word: "bee", count: 1 },
      { word: "bunch", count: 1 },
      { word: "cancelled", count: 1 },
      { word: "celebrated", count: 1 },
      { word: "challenge", count: 1 },
    ],
    A2: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    B1: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    B2: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    C1: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    C2: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    UNLISTED: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
  };
  
  //Dividir los datos obtenidos entre las 3 columnas al expandir la informacion

  public dividedData: DividedData = {};


  divideData() {
    for (const key in this.data) {
      if (this.data.hasOwnProperty(key)) {
        const items = this.data[key];
        const chunkSize = Math.ceil(items.length / 3);
        this.dividedData[key] = [
          items.slice(0, chunkSize),
          items.slice(chunkSize, chunkSize * 2),
          items.slice(chunkSize * 2),
        ];
      }
    }
  }
  
  //Funcion para expandir cada cuadro
  toggleExpand(identifier: string) {
    this.isExpanded[identifier] = !this.isExpanded[identifier];
  }
  toggleExpandAll() {
    const newState = !this.isExpanded['A1'] || !this.isExpanded['A2'] || !this.isExpanded['B1'] || !this.isExpanded['B2'] || !this.isExpanded['C1'] || !this.isExpanded['C2'] || !this.isExpanded['UNLISTED'] ;
    this.isExpanded['A1'] = newState;
    this.isExpanded['A2'] = newState;
    this.isExpanded['B1'] = newState;
    this.isExpanded['B2'] = newState;
    this.isExpanded['C1'] = newState;
    this.isExpanded['C2'] = newState;
    this.isExpanded['UNLISTED'] = newState;
}

  constructor(private analysisService: AnalysisServiceService,) {
    this.checked = true;
    this.divideData();
  }

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }
 
  //Variables Pagina 2 WordCharts
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {
        grid: {
          display: false,  // Ocultar las líneas verticales
        },
      },
      y: {
        min: 0,
        max: 50,  // Límite máximo del eje Y en 25%
        ticks: {
          stepSize: 10,  // Incrementos de 5% en 5%
        },
        border: {
          display: false  // Eliminar el borde del eje Y
        },
        grid: {
          color: '#E0E0E0',  // Color de las líneas horizontales
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Ocultar la leyenda
      },
      datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
    },
  };
  
  
  public barChartType = 'bar' as const;
  
  public barChartData: ChartData<'bar'> = {
    labels: ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'],
    datasets: [
      { 
        data: [40, 10, 7.5, 7.5, 2.5, 1.5],
        label: 'Knowledge Rank %',
        backgroundColor: [
          '#FF5722',  // Naranja
          '#009688',  // Verde
          '#F44336',  // Rojo
          '#4CAF50',  // Verde claro
          '#3F51B5',  // Azul
          '#9C27B0',  // Púrpura
        ],
        // Hace las barras más delgadas
        barThickness: 40,
      },
    ],
  };

  //Para el cambio de color de los ojos
  toggleEyeIcon(event: Event): void {
    const element = event.target as HTMLImageElement;

    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }
}
